import { useTranslation } from 'react-i18next'

import TicketImage from 'shared/images/ticket_buy.png'
import { priceShow } from 'shared/lib//priceShow'
import { Button } from 'shared/ui/button'

import styles from './styles.module.scss'

interface Props {
  price: string
  onContinue?: () => void
  onBack?: () => void
}

const PriceChanged = ({ price, onBack, onContinue }: Props) => {
  const { t } = useTranslation()

  return (
    <div className={styles.container}>
      <div className={styles.image}>
        <img
          src={TicketImage}
          alt=""
        />
      </div>

      <h3 className={styles.title}>{t('purchase_page.price_changed_title')}</h3>
      <p className={styles.desc}>{t('purchase_page.price_changed_desc')}</p>

      <p className={styles.newPrice}>{t('purchase_page.new_price')}</p>

      <p className={styles.price}>{priceShow(price)} &#8384;</p>

      <div className={styles.wrapperButton}>
        <div className={styles.button}>
          <Button
            style={{ borderRadius: 14 }}
            onClick={onContinue}
          >
            <span className={styles.text}>{t('continue')}</span>
          </Button>
        </div>
        <div className={styles.button}>
          <Button
            style={{ borderRadius: 14 }}
            variant="transparent"
            onClick={onBack}
          >
            <span className={styles.textError}>{t('refuse')}</span>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default PriceChanged
